import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Hero() {
  return (
    <section className="min-h-screen flex flex-col justify-center items-start relative overflow-hidden pt-32 pb-24 px-8 z-10">
      <div className="hero-bg-lines absolute inset-0 pointer-events-none overflow-hidden"></div>
      
      <div className="relative z-10 max-w-[1100px] w-full mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-[0.75rem] font-bold tracking-[0.25em] uppercase text-brand-gold mb-8 flex items-center gap-4"
        >
          <motion.div 
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="w-12 h-[1px] bg-brand-gold origin-left"
          />
          Executive Sparringpartner · Wien · DACH
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="text-[clamp(3.5rem,8vw,7rem)] font-light leading-[1.0] text-brand-white tracking-[-0.03em] mb-12 font-serif"
        >
          Ihr Unternehmens&shy;wert.<br/>
          Verdoppelt.<br/>
          <em className="text-brand-gold font-light not-italic italic">In 36 Monaten.</em>
        </motion.h1>

        <motion.div 
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="inline-flex items-start gap-5 bg-brand-surface border border-brand-border border-l-[4px] border-l-brand-gold p-7 mb-14 max-w-[650px] shadow-2xl"
        >
          <svg className="w-6 h-6 shrink-0 mt-[2px] text-brand-gold" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"/>
          </svg>
          <div className="text-[1rem] text-brand-text leading-relaxed">
            <strong className="font-bold text-brand-white">Garantie:</strong> Verdoppelung Ihres Unternehmenswertes in maximal 36 Monaten — tritt das Ziel früher ein, umso besser. Danach arbeite ich kostenlos weiter, bis es erreicht ist.
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="flex items-center gap-8 flex-wrap"
        >
          <a href="#kontakt" className="inline-block bg-brand-gold text-brand-black text-[0.8rem] font-bold tracking-[0.12em] uppercase py-4 px-10 rounded-sm transition-all duration-300 hover:bg-brand-gold2 hover:-translate-y-1 shadow-lg">
            Kostenloses Erstgespräch anfragen
          </a>
          <a href="#struktur" className="group inline-flex items-center gap-3 text-brand-text text-[0.85rem] font-semibold tracking-[0.05em] transition-colors duration-200 hover:text-brand-gold">
            Wie es funktioniert
            <SafeIcon icon={FiArrowRight} className="transition-transform duration-300 group-hover:translate-x-2" />
          </a>
        </motion.div>
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="hidden xl:flex absolute right-12 bottom-16 flex-col gap-10 z-10"
      >
        {[
          { num: '3', label: 'Kreise · je Zielgruppe' },
          { num: '4', label: 'Mitglieder pro Kreis' },
          { num: '12', label: 'Partner insgesamt' },
          { num: '36M', label: 'Garantie-Zeithorizont' }
        ].map((stat, i) => (
          <div key={i} className="text-right">
            <div className="font-serif text-[3rem] font-light text-brand-white leading-none tracking-[-0.02em]">{stat.num}</div>
            <div className="text-[0.7rem] font-bold tracking-[0.15em] uppercase text-brand-muted mt-2">{stat.label}</div>
          </div>
        ))}
      </motion.div>
    </section>
  );
}